import React, { useEffect, useState } from 'react';
import {
  GetAllSlaConfiguration,
  UpsertSlaConfiguration,
} from '../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { showError } from '../../../../../Helper';
import { Spinner } from '../../../../../Components';
import { ButtonBase } from '@material-ui/core';
import SLAConfigurationFields from './Components/SLAConfigurationFields';
import InfoNoticeBox from '../../Utilities/InfoNoticeBox';
import { infoPoints } from './Components/infoPoints';

export default function SLAConfiguration({ parentTranslationPath, translate }) {
  const [isLoading, setIsLoading] = useState(false);
  const [slaConfigurationData, setSlaConfigurationData] = useState({});

  const getAllSlaConfiguration = async () => {
    setIsLoading(true);
    try {
      const result = await GetAllSlaConfiguration();
      setSlaConfigurationData(result);
    } catch (error) {
      showError('something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateSLAConfiguration = async () => {
    setIsLoading(true);
    try {
      await UpsertSlaConfiguration(slaConfigurationData);
    } catch (error) {
      showError('something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllSlaConfiguration();
  }, []);
  return (
    <div className='leadxchange-config-container'>
      <div className='leadxchange-card-wrapper'>
        <Spinner isActive={isLoading} />

        <div className='leadxchange-card-header'>
          <div className='leadxchange-card-header-wrapper'>
            <span>{translate('SLA configuration ')}</span>
            <ButtonBase
              className='btns theme-propx solid'
              onClick={handleUpdateSLAConfiguration}
            >
              Save changes
            </ButtonBase>
          </div>
          <span className='field_divider'></span>
        </div>
        <div className='leadxchange-card-content'>
          <SLAConfigurationFields
            parentTranslationPath={parentTranslationPath}
            translate={translate}
            slaConfigurationData={slaConfigurationData}
            setSlaConfigurationData={setSlaConfigurationData}
          />
        </div>
      </div>
      <InfoNoticeBox
        infoTitle={'What happens when rules are triggered?'}
        infoPoints={infoPoints}
        translate={translate}
      />
    </div>
  );
}
